import(/* webpackMode: "eager" */ "/codebuild/output/src2116344597/src/rmh-platform/packages/ui/src/assets/images/not-found.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2116344597/src/rmh-platform/packages/ui/src/index.tsx");
